import React from 'react'

import {
  Box,
  Card,
  CardHeader,
  Text,
  Link,
  Button,
  Center,
} from '@chakra-ui/react'

class confirmation extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      base: '',
    }
  }

  componentDidMount() {
    const hostname = window.location && window.location.hostname
    const base = hostname.includes('localhost')
      ? 'https://secure-dev.republicfinance.com'
      : `https://${hostname}`

    this.setState({base})
  }

  render() {
    if (this.props.currentStep !== 6) {
      return null
    }
    return (
      <Box bg="#EBF9FF">
        {' '}
        <Center>
          <Card m={10} p={10} maxW={'480px'} boxShadow="xl" mb={10}>
            <CardHeader>
              <Text textStyle="t6" as="b" color="pb100">
                {' '}
                {this.props.enrollingError
                  ? 'We’re not able to enroll you at this time'
                  : ' You’re enrolled!'}
              </Text>
            </CardHeader>
            <Box ml={5} mb={8}>
              {this.props.enrollingError ? (
                <Text textStyle="b2">
                  We’re sorry, but we ran into an issue creating your account.
                  Please contact our customer support team at (833) 907-1737 for
                  help with enrolling.
                </Text>
              ) : (
                <Text textStyle="b2">
                  You can now sign in to your account using the email and
                  password you created.
                </Text>
              )}
            </Box>{' '}
            <Link
              isExternal
              href={`${this.state.base}/apps/account/callback`}
              _hover={{textDecoration: 'none'}}
            >
              {' '}
              <Center>
                {this.props.enrollingError ? null : (
                  <Button ml={5} mr={5} w="100%">
                    {' '}
                    Go to Sign In Page
                  </Button>
                )}
              </Center>
            </Link>
          </Card>
        </Center>
      </Box>
    )
  }
}

export default confirmation
